import React from 'react';

export const Table = ({ className = '', children, ...props }) => (
  <div className="w-full overflow-x-auto">
    <table className={`w-full text-left border-collapse ${className}`} {...props}>
      {children}
    </table>
  </div>
);

export const Thead = ({ className = '', children, ...props }) => (
  <thead className={`bg-gray-50/80 border-b border-gray-100 ${className}`} {...props}>
    {children}
  </thead>
);

export const Tbody = ({ className = '', children, ...props }) => (
  <tbody className={`divide-y divide-gray-50 ${className}`} {...props}>
    {children}
  </tbody>
);

export const Tr = ({ className = '', children, ...props }) => (
  <tr className={`hover:bg-gray-50/50 transition-colors group ${className}`} {...props}>
    {children}
  </tr>
);

export const Th = ({ className = '', children, ...props }) => (
  <th className={`px-4 py-3 text-[11px] font-bold text-gray-900 uppercase tracking-wide ${className}`} {...props}>
    {children}
  </th>
);

export const Td = ({ className = '', children, ...props }) => (
  <td className={`px-4 py-3 text-[13px] text-gray-700 align-middle ${className}`} {...props}>
    {children}
  </td>
);
